import React, { ReactElement, useState } from 'react';
import storeConnector from '@store/storeConnector';
import { SiteMeta } from '@src/types/SiteMeta';
import {
  DcBusData,
  DcBus,
  Module,
  Transformer,
} from '@src/sld/components/Shared';
import { useWsSubscribe } from '../../../store/actionCreators/mqtt';

interface Section1DevicesProps {
  siteMeta: SiteMeta;
}
function Section1Devices(props: Section1DevicesProps): ReactElement {
  const { siteMeta } = props;
  const [dcBusData, setDcBusData] = useState<DcBusData>({});
  useWsSubscribe({
    pcs: {
      fields: ['DCkW', 'Hz', 'PF', 'DCV', 'DCA', 'DCDisconnect'],
      sns: [siteMeta.UnitsPV[0]],
      cb: (incoming: DcBusData) =>
        setDcBusData((prev) => ({ ...prev, ...incoming })),
    },
  });
  return (
    <g>
      <g id='inv1-pcs1' transform='translate(339.212 -96.816)'>
        <DcBus data={dcBusData} />
      </g>
      <g id='inv1-mod1' transform='translate(354.645 -222.181)'>
        <Module label='INV 1 - MOD 1' status={dcBusData.DCDisconnect} />
      </g>
      <g id='inv1-xfmr1' transform='rotate(90 393.195 804.035)'>
        <Transformer label='INV 1 - XMFR' />
      </g>
    </g>
  );
}

const Section1DevicesContainer = storeConnector(Section1Devices, {
  config: ['siteMeta'],
});
function Section1Connectors(): ReactElement {
  return (
    <g>
      <g id='xfrm1-psmg1' transform='rotate(90 416.022 797.659)'>
        <path d='M0 792h37.43' />
      </g>
      <g id='inv1-mod1-xfmr1' transform='translate(367.989 -248.869)'>
        <path d='M0 792v-56.28h53.69v-51.35' />
      </g>
      <g id='inv1-mod1-foreignobject1' transform='translate(358.989 -222.181)'>
        <path d='M9 792v67.81' />
      </g>
    </g>
  );
}
function Section1(): ReactElement {
  return (
    <g>
      <Section1DevicesContainer />
      <Section1Connectors />
    </g>
  );
}

export default Section1;
